export function buildLivingSoilsUrl(path = "/") {
  return new URL(path, window.location.origin).toString();
}

export function logoutToLivingSoilsHome(keycloak) {
  if (!keycloak) return;
  keycloak.logout({
    redirectUri: buildLivingSoilsUrl("/"),
  });
}
